import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { LeaderboardEntry, StatsMode, StatsPeriod } from '../api/types';

interface LeaderboardState {
  rows: LeaderboardEntry[];
  loading: boolean;
  error: string | null;
}

/** Rangliste fürs gewählte Zeitfenster; lädt bei Toggle-Wechsel neu. */
export function useLeaderboard(period: StatsPeriod, mode: StatsMode): LeaderboardState {
  const [state, setState] = useState<LeaderboardState>({ rows: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    const params = new URLSearchParams({ period });
    if (period !== 'all') params.set('mode', mode);

    api
      .get<LeaderboardEntry[]>(`/stats/leaderboard?${params.toString()}`)
      .then((res) => {
        if (cancelled) return;
        setState({ rows: res.data, loading: false, error: null });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ rows: [], loading: false, error: 'Rangliste konnte nicht geladen werden' });
      });

    return () => {
      cancelled = true;
    };
  }, [period, mode]);

  return state;
}
